import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NavStatusService} from "../nav-status.service";
import {NavigationPoint} from "../navigation-point";
import {AdminService} from "./admin.service";
import {UserStub} from "./user-stub";
import {MatSort, MatSortHeader} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef,
  MatTable,
  MatTableDataSource
} from "@angular/material/table";
import {DateLocalePipe} from "../common/pipes/date-locale.pipe";
import {MatIcon} from "@angular/material/icon";
import {TranslatePipe} from "@ngx-translate/core";
import {MatButton} from "@angular/material/button";
import {FullHeighDirective} from "../common/full-heigh.directive";
import {MatDialog} from "@angular/material/dialog";
import {AdminEditUserComponent} from "./admin-edit-user/admin-edit-user.component";
import {AdminUser} from "./admin-user";
import {EditUserData} from "./edit-user-data";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {Role} from "./role";
import {UserService} from "../user/user.service";
import {UserStateService} from "../user/user.state.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-user-admin',
  imports: [
    MatTable,
    MatPaginator,
    MatSort,
    MatColumnDef,
    MatCell,
    MatHeaderCell,
    DateLocalePipe,
    MatCellDef,
    MatHeaderCellDef,
    MatHeaderRow,
    MatRow,
    MatHeaderRowDef,
    MatRowDef,
    MatSortHeader,
    MatIcon,
    TranslatePipe,
    MatButton,
    FullHeighDirective,
    MatFormFieldModule,
    MatInput
  ],
  templateUrl: './user-admin.component.html',
  styleUrl: './user-admin.component.scss'
})
export class UserAdminComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(private navStatusService: NavStatusService, private adminService: AdminService,
              private dialog: MatDialog,
              private userService: UserService,
              private userStateService: UserStateService,
              private router: Router) {
  }
  users: UserStub[] | undefined;
  dataSource = new MatTableDataSource<UserStub>();
  displayedColumns: string[] = ['firstName', 'lastName', 'email', 'roles', 'createdAt', 'updatedAt', 'icons'];
  roles: Role[]  = []
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort: MatSort | undefined;
  ngOnInit() {
    this.navStatusService.setActiveNavPoint(NavigationPoint.userAdmin);
    this.getRoles();
    this.getUsers();
  }
  getUsers() {
    this.adminService.getUsers().subscribe(res => {
      this.users = res.data;
      this.dataSource.data = this.users;
    })
  }
  getRoles() {
    this.adminService.getRoles().subscribe(res => {
      this.roles = res.data;
    })
  }
  ngAfterViewInit() {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
  }
  doFilter = (e: any) => {
    this.dataSource.filter = e.target.value.trim().toLocaleLowerCase();
  }
  newUser() {
    this.editUser(undefined, false);
  }
  editUser(user?: UserStub, basedOnCopy?: boolean) {
    const editUserData: EditUserData = {
      userId: (user && !basedOnCopy) ? user.id : undefined,
      userStub: basedOnCopy? user : undefined,
      availableRoles: this.roles
    }
    const ref = this.dialog.open(AdminEditUserComponent, {
      width: '800px',
      data: editUserData,
      autoFocus: false,
    })
    ref.afterClosed().subscribe(result => {
      if (result) {
        if (result && result.id) {
          this.updateUser(result);
        } else {
          this.createUser(result);
        }
      }
    })
  }
  createUser(user: AdminUser) {
    this.adminService.createUser(user).subscribe(res => {
      if (res) {
        this.getUsers();
      }
    })
  }
  updateUser(user: AdminUser) {
    this.adminService.updateUser(user).subscribe(res => {
      if (res) {
       this.getUsers()
      }
    })
  }
  loginAs(user: AdminUser) {
   /* this.userService.switchUser(user).subscribe(user => {
      console.log(user);
      this.userStateService.user = user;
      this.router.navigate(['/']);
    })*/
    this.userService.switchUserPost(user).subscribe(res => {
      if (res && res.ok) {
        // console.log('res', res);
        this.userService.getLoggedInUser().subscribe(res => {
          if (res) {
            this.userStateService.user = res;
            this.router.navigate(['/']).then();
          }
        })
      }
    })
  }

  ngOnDestroy() {

  }

}
